module.exports = __webpack_public_path__ + "img/tu8.78d9e418.png";